import React from "react";
import {renderMarkdownWithInterpolation} from "../../../markdown/markdown-factory";
import {TEMPLATE_CONSTANTS} from "../../../markdown";
import {TDL_Default} from "../../../markdown/token-details/templates";
import MoleculeImage from "../../MoleculeImage";
import {
  MDCollapsibleList,
  MDCollapsibleText
} from "../../results-grid/grid-row/MDCollapsibleContent";

import {markMatchingText} from "../../../markdown/utils";

const TokenItemDetail = ({
  entity,
  onItemDelete,
  templates,
}) => {
  // Determine what to highlight based on entity type
  // For SMILES/InChI/query entities, highlight the title instead of the ID
  const matchTerm = entity['match-term'];
  const matchField = entity['match-field'];
  const isEncodingMatch = matchField === 'smiles' || matchField === 'inchi' || matchField === 'inchikey' ||
                          matchField === 'id' || /^(smiles|inchi|query):/.test(entity.id);

  // Create a custom markText function that only highlights the title for encoding-based matches
  const customMarkText = matchTerm ? ((text, options = {}) => {
    // For encoding-based entities, only highlight if the text matches the title
    if (isEncodingMatch) {
      // Only apply highlighting to the title field, not to IDs or SMILES strings
      if (text === entity.title || (entity.title && text.includes(entity.title))) {
        return markMatchingText(text, matchTerm, options);
      }
      return text;
    }
    // For other entities, highlight all matching text as usual
    return markMatchingText(text, matchTerm, options);
  }) : null;

  return (
    <div className={`token-details-body${entity.ambiguous ? ' alert-warning' : ''}`}>
      {renderMarkdownWithInterpolation({
                                         templateType: TEMPLATE_CONSTANTS.TOKEN_DETAILS,
                                         templates,
                                         templateOverrides: {
                                           SMILES: {
                                             component: MoleculeImage,
                                             props: {encoding: entity.smiles || entity.inchi},
                                           },
                                           Text: {
                                             component: MDCollapsibleText
                                           },
                                           List: {
                                             component: MDCollapsibleList
                                           }
                                         },
                                         entity,
                                         markText: customMarkText,
                                         fallback: TDL_Default})}
      <span
        className="delete-search-term"
        aria-hidden="true"
        onClick={x => onItemDelete(entity.id)}
      >
        ×
      </span>
    </div>
  );
};

export default TokenItemDetail;
